import React from "react";
import { Typography } from "@mui/material";

const BaseTypography = ({ variant = "body1", children, sx = {}, ...props }) => (
  <Typography variant={variant} sx={{ color: "text.primary", ...sx }} {...props}>
    {children}
  </Typography>
);

export default BaseTypography;
